/**
 * Бэкенд отдаёт одно поле org_structure_name (обычно по-русски).
 * Известные системные отделы переводим на языке сайта; остальные имена
 * показываем как прислал API — для них нужны name_en / name_tj на бэке.
 */
const ORG_STRUCTURE_LABEL_IDS: Record<string, string> = {
  'методологический отдел': 'component.contextSwitcher.org.methodologicalDepartment',
  'methodological department': 'component.contextSwitcher.org.methodologicalDepartment',
  'шуъбаи методологӣ': 'component.contextSwitcher.org.methodologicalDepartment',
  'отдел разработки': 'component.contextSwitcher.org.developmentDepartment',
  'development department': 'component.contextSwitcher.org.developmentDepartment',
  'шуъбаи барномасозӣ': 'component.contextSwitcher.org.developmentDepartment',
};

function normalizeOrgName(name: string): string {
  return name.trim().replace(/\s+/g, ' ').toLowerCase();
}

export function translateOrgStructureName(
  intl: { formatMessage: (desc: { id: string; defaultMessage?: string }) => string },
  name?: string | null,
): string | null {
  if (!name) return null;
  const id = ORG_STRUCTURE_LABEL_IDS[normalizeOrgName(name)];
  if (!id) return name;
  return intl.formatMessage({ id, defaultMessage: name });
}
